// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atom-content-text{text-align:justify;text-justify:inter-word}.atom-content-text p{color:#fff;font-family:\"effra\",Arial,sans-serif;font-size:.875rem;font-weight:400;line-height:1.5rem}@media only screen and (max-width:767px){.atom-content-text p{color:#fff;font-family:\"effra\",Arial,sans-serif;font-size:.875rem;font-weight:400;line-height:1.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
